/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentIntegrationType {
  GROW_PAYMENTS = 'grow_payments',
  TRANZILA_PAYMENTS = 'tranzila_payments',
  PAY_PLUS_PAYMENT = 'pay_plus_payment',
  GREEN_INVOICE_PAYMENT = 'green_invoice_payment',
  STRIPE_CONNECT = 'stripe_connect',
  SQUARE_CONNECT = 'square_connect',
  NO_INTEGRATION = 'no_integration',
}
